<div class="places-autocomplete-container">
  <div class="custom-search-input">
    <input #searchInput [formControl]="searchControl" type="text" [placeholder]="placeholder" class="search-input"
      [ngClass]="{'input-error': hasError && isTouched}" (blur)="onBlur()" (focus)="onFocus()"
      (keydown)="onInputKeydown($event)" (keydown.enter)="onEnterWithoutPredictions($event)" role="combobox"
      [attr.aria-expanded]="showPredictions && predictions.length > 0" aria-autocomplete="list" aria-haspopup="listbox"
      aria-controls="predictions-list"
      [attr.aria-activedescendant]="activePredictionIndex >= 0 ? getPredictionId(activePredictionIndex) : null" />
    <button *ngIf="searchControl.value && !isLoading" (click)="clearSearch()" class="clear-button" type="button"
      [attr.aria-label]="'Limpiar dirección'">
      ✕
    </button>
  </div>

  <div class="predictions-container" [ngClass]="{noAbsolutePosition: 'predictions-container-no-absolute'}"
    *ngIf="showPredictions && predictions.length > 0" id="predictions-list" role="listbox">
    <div class="prediction-item" *ngFor="let prediction of predictions; let i = index; trackBy: trackByPrediction"
      [id]="getPredictionId(i)" role="option" [attr.aria-selected]="isPredictionActive(i)"
      [class.active]="isPredictionActive(i)" (mouseenter)="onPredictionMouseEnter(i)"
      (mousedown)="selectPrediction(prediction)">
      <span>
        <img src="assets/icons/backoffice/pointer.svg" alt="pointer" class="prediction-icon">
      </span>
      <span class="prediction-text-wrapper">
        <span class="prediction-main-text">{{ getFormattedMainText(prediction) }}</span>
        <span class="prediction-secondary-text" *ngIf="getFormattedSecondaryText(prediction)">
          {{ getFormattedSecondaryText(prediction) }}
        </span>
      </span>
    </div>
  </div>

  <div class="loading-indicator" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <div *ngIf="hasError && isTouched" class="error">
    {{ errorMessage }}
  </div>
</div>